import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportLoadingChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.trips.averageLoadingTime",
		title: "Avg. Loading Time",
		yAxisLabel: "Time (Hours)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.trips.averageLoadingTime,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.trips.averageLoadingTime );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};

